import Vue from "vue";
import store from "@/store";
import router from "@/routes";

export * from './attachment'
export * from './oss-file'

export const createDialog = (
  VueComponentOptions,
  params = { autoDestroy: false }
) => {
  let instance; // 组件实例
  let compCreater; // 组件的构建配置对象
  let destroy = () => {
    if (instance) {
      instance.$destroy();
      instance.$el.remove();
      instance = null;
    }
  };
  return {
    async create(options = {}, cb = () => {}) {
      if (typeof options === "function") {
        cb = options;
        options = {};
      }
      if (options.destroy || params.autoDestroy) {
        destroy();
      }
      if (!instance) {
        // 如果 VueComponentOptions 是函数，则读取执行后的结果
        if (typeof VueComponentOptions === "function") {
          // 缓存加载结果
          compCreater = compCreater || (await VueComponentOptions()).default;
        } else {
          compCreater = VueComponentOptions;
        }

        const Ctor = Vue.extend(compCreater);
        instance = new Ctor({
          _parentListeners: { ...(options.on || {}) },
          ...options,
          store,
          router,
        });

        // 为修复antd重复渲染BUG
        instance.constructor = Vue;

        instance.$mount();

        // 监听路由变化及时销毁弹窗
        instance.$watch("$route.path", () => {
          destroy();
        });

        // 弹窗关闭时自动销毁组件
        if (options.destroy || params.autoDestroy) {
          instance.$watch("visible", () => {
            if (instance.visible === false) {
              setTimeout(() => {
                destroy();
              }, 300);
            }
          });
        }

        // 弹窗关闭时自动销毁组件
        if (options.destroy || params.autoDestroy) {
          instance.$watch("visible", () => {
            if (instance.visible === false) {
              setTimeout(() => {
                destroy();
              }, 300);
            }
          });
        }

        const owner = this;
        if (owner && owner._isVue) {
          let d = owner.$options.beforeDestroy;
          owner.$options.beforeDestroy = d
            ? Array.isArray(d)
              ? d.concat(destroy)
              : [d, destroy]
            : [destroy];
        }
        document.body.append(instance.$el);
      }

      Vue.nextTick(() => {
        if (options.propsData) {
          Object.keys(options.propsData).forEach((key) => {
            instance.$props[key] = options.propsData[key];
          });
        }
        instance.visible = true;
        cb(instance);
      });
      return instance;
    },
    destroy,
  };
};

export const generatePromise = () => {
  let resolve, reject;
  const p = new Promise((res, rej) => {
    resolve = res;
    reject = rej;
  });
  return [p, resolve, reject];
};

export const downloadBlob = (blob, filename) => {
  if (typeof window.navigator.msSaveBlob !== "undefined") {
    // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
    window.navigator.msSaveBlob(blob, decodeURI(filename));
  } else {
    // 创建新的URL并指向File对象或者Blob对象的地址
    const blobURL = window.URL.createObjectURL(blob);
    // 创建a标签，用于跳转至下载链接
    const tempLink = document.createElement("a");
    tempLink.style.display = "none";
    tempLink.href = blobURL;
    tempLink.setAttribute("download", decodeURI(filename));
    // 兼容：某些浏览器不支持HTML5的download属性
    if (typeof tempLink.download === "undefined") {
      tempLink.setAttribute("target", "_blank");
    }
    // 挂载a标签
    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
    // 释放blob URL地址
    window.URL.revokeObjectURL(blobURL);
  }
};

export const getDict = (code) => {
  return Vue.prototype.$axios
    .post(
      `/${process.env.VUE_APP_PROXY_DING_OA}/dictionary/getDictionaryListByCode`,
      null,
      {
        params: new URLSearchParams({
          code,
        }),
      }
    )
    .then(({ data }) => {
      return Promise.resolve(data);
    });
};

//数组扁平化
export const flatten = (tree, arr) => {
  let result = arr || [];
  tree.forEach((element) => {
    result.push(element);
    if (element.children.length > 0) {
      flatten(element.children, result);
    }
  });
  return result;
};
// //获取按钮权限
export const getBtnList = (url) => {
  let menuList = store.state.user.allMenu;
  let flattenList = flatten(menuList, []);
  let result = flattenList.filter(
    (_) => _.hasAuth && _.type == "B" && _.url == url
  );
  if (result.length > 0) {
    return true;
  } else {
    return false;
  }
};
/**
 * 接口：获取字典数据
 * @param {String} Type 字典类型
 * @param {Boolean} params.returnOptions // 是否将数据转化为 { label,value }[] 结构
 * @param {Boolean} params.filterStatus // 是否通过status过滤
 * @param {Function} params.valueHandle // 对value的处理，如 Number，String 等
 * @returns
 */
export const getDictionaries = (
  Type,
  params = {}
) => {
  const data = new URLSearchParams();
  let { returnOptions = false, valueHandle, valueKey = "code", filterStatus = true } = params

  data.append("code", Type);
  return Vue.prototype.$axios
    .post(
      `/${process.env.VUE_APP_PROXY_DING_OA}/dictionary/getDictionaryListByCode`,
      data,
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    )
    .then((res) => {
      if (returnOptions) {
        return res.data.filter(item => {
          if (!filterStatus) return true

          return item.status === 1
        }).map((item) => {
          let tempItem = {
            label: item.name,
            value: valueHandle ? valueHandle(item[valueKey]) : item[valueKey],
            row: item
          };
          return tempItem;
        });
      }

      return res.data;
    })
    .finally(() => {});
};
// 根据类名获取类编码/文字
export const getColValCommentList = (classStr) => {
  return Vue.prototype.$axios
    .post(
      `/${process.env.VUE_APP_PROXY_DING_OA}/dictionary/getColValCommentList?classStr=${classStr}`
    )
    .then((res) => res.data)
    .finally(() => {});
};
//四舍五入
export const rounding = (value, digit) => {
  return (
    Math.round(Number(value) * Math.pow(10, digit)) / Math.pow(10, digit)
  ).toFixed(digit);
};

// 替换协议
export function replaceProtocol(url, replacement = "") {
  const regex = /^http(s)?:\/\//g;
  return String(url).replace(regex, replacement);
}

/**
 * @deprecated 过滤字典对应值
 * @param {string | array | number} val 字典value值，翻译多个字典值传入字符串（逗号分割，'1,2,3'）或数组([1,2,3])
 * @param {array} arr 字典数据
 * @param {string} key 翻译属性名
 * @param {string} label 返回属性名
 * @return {string} 返回转换后的字典内容，若val值为数组或多个字典值的字符串（'1,2,3'）,则返回的内容为逗号拼接的字符串
 */
export function dictFilter(val, arr, key = "code", label = "name") {
  if (!val || !arr || arr.length < 1) return "";
  let isNum = typeof val === "number";
  // val不是数字类型且val是数组或逗号拼接的字符串则返回true
  let isArr = !isNum && (val.includes(",") || Array.isArray(val));
  // 若isArr为true，二次判断val是否为逗号拼接的字符串，是字符串则转换为数组，反之直接赋值val；若isArr为false，赋值空字符串
  const splitArr = isArr ? (val.includes(",") ? val.split(",") : val) : "";
  let name = isArr ? [] : "";
  if (isArr) {
    // 遍历val数组
    splitArr.forEach((n) => {
      // 遍历字典数据，若字典值等于字典数据项的key值，则push字典数据的label值
      arr.forEach((k) => {
        if (n === k[key] || n + "" === k[key]) {
          name.push(k[label] || k.label);
        }
      });
    });
  } else {
    // 遍历字典数据，若字典值等于字典数据项的key值，则赋值字典数据的label值
    arr.forEach((n) => {
      if (n[key] === val || n[key] === val + "") {
        name = n[label] || n.label;
      }
    });
  }
  return isArr ? name.join(",") : name;
}
// 当前环境判断
export function env() {
  const { hostname, port } = window.location;
  let env = "pro";
  switch (true) {
    case hostname.includes("uat"):
      env = "uat";
      break;
    case hostname.includes("test") && port == "8185":
      env = "sit01";
      break;
    case hostname.includes("test") && port == "8186":
      env = "sit02";
      break;
    case hostname.includes("localhost"):
      env = "localhost";
      break;
    default:
      env = "pro";
      break;
  }
  return env;
}
// 获取数据类型
export function getDataType(val) {
  return Object.prototype.toString.call(val).slice(8, -1);
}
// 过滤输入大于零的整数
export function formatNumber(val, includesZero = false) {
  const type = getDataType(val);
  if (["String", "Number"].includes(type)) {
    let text = val.toString();
    switch (true) {
      case text.length === 1 && text[0] === "0" && includesZero:
        text = "0";
        break;
      case text[0] === "0" &&
        text.length > 1 &&
        text[1] === "0" &&
        includesZero:
        text = "0";
        break;
      default:
        text = text.replace(/^(0+)|[^\d]+/g, "");
        break;
    }
    return text;
  } else {
    console.warn(`Expected String or Number, got ${type}.`);
  }
}

// 获取数据类型
export function getType(val) {
  if (val === null) return "Null";
  if (val === undefined) return "Undefined";
  let type = Object.prototype.toString.call(val);
  type = type.substring(8, type.length - 1);
  return type;
}

// 设置请求参数
export function setObject(data, t, key) {
  switch (true) {
    case getType(data) === "Array":
      data.forEach((item, idx) => {
        setObject(item, t, `${key}[${idx}]`);
      });
      break;
    case getType(data) === "Object":
      for (let k of Object.keys(data)) {
        if (data[k] !== undefined && data[k] !== null) {
          setObject(data[k], t, key ? `${key}.${k}` : k);
        }
      }
      break;
    default:
      var input = document.createElement("input");
      input.setAttribute("name", key);
      input.setAttribute("value", data);
      t.appendChild(input);
      break;
  }
}

// 文件下载（显示下载进度）
export function downloadFile(url, data, method) {
  let t = document.getElementById("ihr_table_export_form");
  let curMethod = method || "GET";
  if (!t) {
    t = document.createElement("form");
    t.setAttribute("id", "ihr_table_export_form");
    t.setAttribute("style", "display: none");
    t.setAttribute("action", url);
    t.setAttribute("method", curMethod);
    document.body.appendChild(t);
  } else {
    t.setAttribute("action", url);
    t.setAttribute("method", curMethod);
  }
  t.innerHTML = "";
  setObject(data, t);
  t.submit();
}

import SecondaryConfirmation from "@/components/secondaryConfirmationModal/index.vue";
const SecondaryConfirmationService = createDialog(SecondaryConfirmation);
// 二次确认弹窗
export function handleSecondaryConfirmationDialog({
  propsData = {
    row: {},
    title: "",
    contentStr: "",
  },
  isAutoClose = false,
  handleOkCb = () => {},
  handleCancelCb = () => {},
  vueConfigCb = () => {},
}) {
  SecondaryConfirmationService.create(
    {
      destroy: true,
      //传参
      propsData,
      //父组件监听子组件派发回来的事件
      _parentListeners: {
        handleOk: async (that) => {
          handleOkCb(that, propsData.row || {});
          if (isAutoClose) {
            that.visible = false
            that.confirmLoading  = false
          }
        },
        handleCancel: handleCancelCb
      },
    },
    (vue) => {
      vueConfigCb(vue);
    }
  );
}

export const confirmDialog = handleSecondaryConfirmationDialog

export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

// 判断是否是移动端
export function isMobile() {
  const flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
  return flag;
}

//阿拉伯数字转中文数字
export function NoToChinese(num) {
  if (!/^\d*(\.\d*)?$/.test(num)) {
    return console.error("Number is wrong!");
  } else if ([0, '0'].includes(num)) {
    return '零'
  }
  let AA = new Array("零", "一", "二", "三", "四", "五", "六", "七", "八", "九");
  let BB = new Array("", "十", "百", "千", "万", "亿", "点", "");
  let a = ("" + num).replace(/(^0*)/g, "").split("."),
      k = 0,
      re = "";
  for (let i = a[0].length - 1; i >= 0; i--) {
      switch (k) {
          case 0:
              re = BB[7] + re;
              break;
          case 4:
              if (!new RegExp("0{4}\\d{" + (a[0].length - i - 1) + "}$").test(a[0]))
                  re = BB[4] + re;
              break;
          case 8:
              re = BB[5] + re;
              BB[7] = BB[5];
              k = 0;
              break;
      }
      if (k % 4 == 2 && a[0].charAt(i + 2) != 0 && a[0].charAt(i + 1) == 0) re = AA[0] + re;
      if (a[0].charAt(i) != 0) re = AA[a[0].charAt(i)] + BB[k % 4] + re;
      k++;
  }
  if (a.length > 1) //加上小数部分(如果有小数部分) 
  {
      re += BB[6];
      for (let i = 0; i < a[1].length; i++) re += AA[a[1].charAt(i)];
  }
  return re;
}

import {companyDepartmentAttr} from '@/assets/data/index.js'
/**
 * @description: 获取一级部门数据
 * @param {Boolean} isShowCompany 是否显示全司选项
 * @return {Array}
 */
export const getOneLevelDepartment = (isShowCompany) => {
  return Vue.prototype.$axios
    .get(
      `/${process.env.VUE_APP_PROXY_DING_OA}/selector/department`,
      {
        params: {
          parentId: companyDepartmentAttr.departmentId,
        },
      },
      { type: "form", uselsmyAccount: true }
    )
    .then(({ data }) => {
      if (isShowCompany) data.unshift(companyDepartmentAttr);
      return Promise.resolve(data);
    });
};


/**
 * @description 数值转换金额,千分符分隔
 * @param {String || Number} num 转换的数据
 * @param {Number} toFixed 小数点后保留位数，默认2位
 * @param {Boolean} isShowDefaultFixed 没有小数位时，是否展示默认小数位，例如0.00，默认不展示
 * @param {String} emptyStr 空值时展示内容
 * @returns 转换后的金额
 */
export function moneyFormat(num, toFixed = 2, isShowDefaultFixed = false, emptyStr) {
  if ([0, "0", "0.00"].includes(num))
    return isShowDefaultFixed ? (+num).toFixed(toFixed) : num;
  if (!+num && emptyStr) return emptyStr;
  const isNegativeNumber = num < 0 ? '-' : ''
  num = isNegativeNumber ? Math.abs(num) : num
  let n = (+num).toFixed(toFixed);
  let [int, dec] = n.split(".");
  let mod = int.length % 3;
  let result = int.substring(0, mod);
  for (let i = int.length % 3; i < int.length; i += 3) {
    result += (i ? "," : "") + int.substring(i, i + 3);
  }
  // 有小数点或显示小数点时
  return +dec || isShowDefaultFixed ? isNegativeNumber + result + "." + dec : isNegativeNumber + result;
}

// 检查空值，兼容NaN、空对象、空数组
export function isNilOrEmpty(value) {
  return value == null || // 检查 null 或 undefined
         value === '' || // 检查空字符串
         (Array.isArray(value) && value.length === 0) || // 检查空数组
         (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0) || // 检查空对象
         (typeof value === 'number' && isNaN(value)); // 检查 NaN
}


// 计算文本的宽度
export const getStringWidth = (string, fontSize) => {
  let span = document.createElement('span');
  span.style.fontSize =+
    fontSize === Number(fontSize) ? `${fontSize}px` : fontSize;
  span.style.position = 'absolute';
  span.style.zIndex = '-999';
  span.innerHTML = string;
  document.body.appendChild(span);
  let ret = span.offsetWidth;
  document.body.removeChild(span);
  return ret;
};

// 下载导入模板
export const downLoadTemplate = (fileName) => {
  const data = new URLSearchParams();
  data.append('fileName', fileName);
  Vue.prototype.$axios
    .get(
      `/${process.env.VUE_APP_PROXY_DING_OA}/fileTemplateApi/downTemplateFile?${data}`,
      {
        responseType: 'blob'
      }
    )
    .then(({ data, headers }) => {
      const filename = headers['content-disposition'].match(
        /filename=(.*)/
      )[1];
      downloadBlob(data, decodeURIComponent(filename));
      Vue.prototype.$message.success('模板下载成功');
    });
}

/**
 * 解析HTML字符串，提取纯文本内容
 * @param {String} htmlString HTML字符串
 * @param {Object} config 配置项
 * @param {Boolean} config.isChangeImgToText 是否替换图片为文字
 * @returns {String} 提取的纯文本内容
 */
export function parseHtmlToText(htmlString, config = {}) {
  if (!htmlString || typeof htmlString !== 'string') {
    return '';
  }

  // 替换图片为文字
  const { isChangeImgToText = false } = config;
  if (isChangeImgToText) {
    htmlString = htmlString.replace(/<img[^>]*>/g, (match) => {
      return match.replace(/<img[^>]*>/g, '【图片】');
    });
  }
  
  // 创建临时DOM元素
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = htmlString;
  
  // 提取纯文本内容
  const text = tempDiv.textContent || tempDiv.innerText || '';
  
  // 清理多余的空格和换行
  return text.replace(/\s+/g, ' ').trim();
}